<div class="section-menu">
  <div class="section-menu__header">
    {{ appState.isTeleInterviewerLoggedIn ? 'CMI Progress' : 'Application Progress' }}
  </div>
  <div class="section-menu__body">
    <div class="section-menu__section-row-list">
      <div class="section-menu__section-row" *ngFor="let section of appState.appMetadata.children; let i = index">
        <section-row-ca
          (sectionRowClicked)="navigate($event)"
          [sectionName]="section.section"
          (numberOfTotalQuestionsEmitter)="onNumberOfTotalQuestionsChange($event)"
          (numberOfAnsweredQuestionsEmitter)="onNumberOfAnsweredQuestionsChange($event)"
          [shouldHideProgress]="(i === 0 && appState.isTeleInterviewerLoggedIn) || isError(section)"
          [isError]="isError(section)"
        ></section-row-ca>
      </div>
    </div>
    <div class="section-menu__footer">
      <ng-container *ngIf="appState.isAdvisor && !appIsLocked">
        <div class="section-menu__send">
          <button
            debounceClickEvent
            class="button button--primary button--yellow"
            [disabled]="sendDisabled"
            [ngClass]="{ 'button--disabled': sendDisabled }"
            (debounceClick)="send()"
            [debounceTime]="500"
          >
            {{ appState.isTeleInterviewerLoggedIn ? 'Ready to Submit' : 'Ready to send' }}
          </button>
        </div>
        <div class="section-menu__save-and-exit">
          <button class="button button--transparent" (click)="exit()">Save &amp; Exit</button>
        </div>
      </ng-container>
      <ng-container *ngIf="!appState.isAdvisor">
        <div class="section-menu__save-and-exit">
          <button class="button button--primary button--yellow" (click)="exit()">Save &amp; Exit</button>
        </div>
      </ng-container>
      <ng-container *ngIf="appIsLocked">
        <div class="section-menu__save-and-exit">
          <button class="button button--primary button--yellow" (click)="back()">
            Back to {{ controller.caseRedesignEnabled ? 'Case' : 'Client' }} Details
          </button>
        </div>
      </ng-container>
    </div>
  </div>
</div>
